import React from 'react'
import Image from '../images/karachi.jpg'

const Karachi_inner = () => {
    return (
        <div className='cities'>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                    <div className="c_img">
                        <img src={Image} alt="Karachi" className='city_img' />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="cities_inner">
                        <h1>Karachi</h1>
                        <p>Karachi is the largest city in Pakistan and the twelfth-largest city in the world. It is the capital of the Pakistani province of Sindh.
                             Ranked as a beta-global city, it is Pakistan's premier industrial and financial centre, with an estimated GDP of $164 billion (PPP) as of 2019.
                              Karachi is Pakistan's most cosmopolitan city, linguistically, ethnically, and religiously diverse, as well as one of Pakistan's most secular and
                               socially liberal cities. With its location on the Arabian Sea, Karachi serves as a transport hub, and is home to Pakistan's two largest seaports,
                                the Port of Karachi and Port Bin Qasim, as well as Pakistan's busiest airport, the Jinnah International Airport.</p>
                                     </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Karachi_inner
